import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=058039ae"
import script from "./ProjectsTable.vue?vue&type=script&lang=js"
export * from "./ProjectsTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectsTable.vue?vue&type=style&index=0&id=058039ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports